import * as React from "react";

import type { DesignaliProps } from "../../types";

export const FilterX = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055" />
        <path d="m22 3-5 5" />
        <path d="m17 3 5 5" />
      </svg>
    );
  },
);

export default FilterX;
